import { localizeValue } from '@mnd-frontend/utils';
import { memo } from 'react';
import styled, { css } from 'styled-components';

const TooltipHeaderStyle = styled.div<{ $hasTotal: boolean }>`
  display: flex;
  align-items: center;
  & + & {
    margin-top: 0.5rem;
  }
  ${({ $hasTotal }) =>
    $hasTotal &&
    css`
      > *:last-child {
        font-weight: 600;
        margin-left: auto;
        padding-left: 2rem;
      }
    `}
`;

const TooltipHeader = memo(
  ({
    name,
    value,
    precision = 0,
    totalText,
  }: {
    name: string;
    value: number;
    precision?: BigIntToLocaleStringOptions['maximumFractionDigits'];
    totalText?: string;
  }) => (
    <TooltipHeaderStyle $hasTotal={!!totalText}>
      <div>{`${name} ${totalText || ''}`.trim()}</div>
      {totalText && (
        <div>{Number.isFinite(value) ? localizeValue(value, { precision }) : value || ''}</div>
      )}
    </TooltipHeaderStyle>
  ),
);

export default TooltipHeader;
